import {
  Router,
  ActivatedRoute,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingPageComponent } from './_shared';
import { LoadingService } from './_shared';
import { AuthenticationService } from './_shared/services';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['../assets/css/core-navbar.css']
})
export class AppComponent implements OnInit {
  // Sets initial value to true to show loading spinner on first load
  public loading = true;

  constructor(
    private title: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });

    this.authenticationService.load();

    this.loadingService.loading$.subscribe((res: boolean) => {
      console.log('loading from child: ', res);
      this.loading = res;
      this.cdr.detectChanges();
    });
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
    }

    // this makes the loading spinner stops before all data loads
    if (event instanceof NavigationEnd) {
      // this.loading = false;
      this.router.events
        .map(() => this.activatedRoute)
        .map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        })
        .filter(route => route.outlet === 'primary')
        .mergeMap(route => route.data)
        .subscribe(event =>
          this.title.setTitle('Customer Portal | ' + event['title'])
        );
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false;
    }
    if (event instanceof NavigationError) {
      this.loading = false;
    }
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/app.component.ts